<template>
  <!-- Top navigation -->
  <DetailTopNav :heading="this.viewType" :subheading="this.assetType" />

  <div
    class="position-absolute v-content d-flex align-items-center text-center z-1"
    v-if="viewType == 'range' || viewType == 'renders'"
  >
    <div class="col-12 h-100 p-0 z-1">
      <div class="row h-100 g-0">
        <div class="col-12 h-100 position-relative z-1">
          <img
            :src="
              theme.cdnUrl +
              '/assets/' +
              assetType +
              '/' +
              viewType +
              '/' +
              this.assetTypes[this.order].LinkName
            "
            class="h-100"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Floorplans -->
  <div
    class="position-absolute v-content d-flex align-items-center text-center z-1"
    v-if="viewType == 'floorplans' && this.assetTypesReady === true"
  >
    <div class="col-12 h-100 p-0 z-1">
      <div class="row h-100 g-0">
        <div class="col-12 h-100 position-relative z-1">
          <img
            :src="
              theme.cdnUrl +
              '/assets/' +
              assetType +
              '/' +
              viewType +
              '/' +
              this.assetTypes[this.order].LinkName
            "
            class="h-100"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Panoramas -->
  <div
    class="position-absolute v-content d-flex align-items-center text-center z-1"
    v-if="viewType == 'earth-tour' || viewType == 'sky-tour'"
  >
    <iframe
      :src="this.assetTypes[this.order].url"
      :title="this.assetTypes[this.order].title"
      width="100%"
      height="100%"
    ></iframe>
  </div>

  <OffCanvas />
</template>

<script>
import DetailTopNav from "@/components/DetailTopNav.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";

export default {
  name: "AssetViewDetail",
  props: ["assetType", "viewType", "order"],
  components: {
    DetailTopNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      assetOrder: null,
      currentAsset: null,
      folderStructure: encodeURIComponent(
        this.theme.devFolder +
          "/assets/type1/" +
          this.assetType +
          "/" +
          this.viewType +
          "/"
      ),
      currentIndex: null,
      assetNames: null,
      assetUrls: null,
      componentName: "AssetView",
      assetTypesReady: false,
    };
  },
  created() {
    console.log(this.viewType);
    if (this.assetType === "type-c-360-tour") {
      if (this.viewType === "videos") {
        this.assetOrder = this.theme.type1Asset.videos;
        this.assetNames = this.theme.type1Asset.videosName;
      } else if (this.viewType === "sky-tour") {
        this.assetOrder = this.theme.type1Asset.floorplans;
        this.assetNames = this.theme.type1Asset.floorplansName;
        this.assetUrls = this.theme.type1Asset.floorplansUrl;
      } else if (this.viewType === "earth-tour") {
        this.assetOrder = this.theme.type1Asset.panoramas;
        this.assetNames = this.theme.type1Asset.panoramasName;
        this.assetUrls = this.theme.type1Asset.panoramasUrl;
      }
    }
    console.log(this.assetUrls);
    console.log(this.folderStructure);
    BunnyNetService.getRenders(this.folderStructure, this.assetType).then(
      (response) => {
        let j = 0;

        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
            title: this.assetNames[j],
            url: this.assetUrls[j],
            id: j++,
          };
        });
        console.log(menuItems);
        // Custom order array based on section and type
        this.assetTypes = menuItems;

        this.assetTypesReady = true;
      }
    );
  },
  methods: {
    // Reorder array based on config setup
    reorder: function (data_array, real_order) {
      var i,
        d = {},
        result = [];
      for (i = 0; i < data_array.length; ++i) {
        d[data_array[i].id] = data_array[i];
      }

      for (i = 0; i < real_order.length; ++i) {
        result.push(d[real_order[i]]);
      }

      return result;
    },
  },
  setup() {
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
